export const ErrorMessage = (message: string) => {
  return (
    <p style={{ color: 'red', fontSize: '10px' }} className="!text-xs">
      {message}
    </p>
  )
}
